import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Col,
  MenuItem,
  Nav,
  NavDropdown,
  Row,
  Tab
} from 'react-bootstrap'

import CompanyTable from './companies/companytable'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'companystates', 'globals'])
export default class Companies extends Component {
  constructor(props) {
    super(props)    
    
    this.props.companystates.loadAllCompanyStates();

    this.state = {
      loadableState: false,
      companyStateHeading: 'Make a selection above',
      companyStateId: 0
    };

    if (this.props.companies.companiesByState != null) {
      this.props.companies.resetCompaniesByState();
    }
  }

  handleCompanyStateSelect(e) {
    this.setState({
      loadableState: true,
      companyStateId: e.id,
      companyStateHeading: e.name
    })

    this.props.companies.loadAllCompaniesByCompanyState(e.id, (data) => {
      this.setState({
        loadableState: false        
      })
    })
  }

  reload(companyStateId, callback) {
    this.props.companies.loadAllCompaniesByCompanyState(companyStateId, () => {
      this.setState({
        companyStateHeading: this.state.companyStateHeading
      })

      if (callback != null) {
        callback()
      }
    })
  }

  render() {

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          { /*
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Link to="/">Home</Link> / Companies
              </Breadcrumb>
            </div>
          </div>
          */ }
          <div className="clearfix"></div>
            <Tab.Container id="tabs-with-dropdown" defaultActiveKey="first" onSelect={ this.handleCompanyStateSelect.bind(this) }>
              <Row className="clearfix">
                <Col sm={12}>
                  <Nav bsStyle="tabs">
                    <NavDropdown eventKey="1" title="Company States">
                    {
                      this.props.companystates.data.map((item) => {
                        return <MenuItem key={'item-' + item.name } eventKey={ item }>{ item.name }</MenuItem>
                      })
                    }
                    </NavDropdown>
                  </Nav>
                </Col>
              </Row>
            </Tab.Container>
        </div>
        <div>
          <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
            <CompanyTable companyStateHeading={ this.state.companyStateHeading } companyStateId={ this.state.companyStateId } data={ this.props.companies.companiesByState } reload={ this.reload.bind(this) } />
          </Loadable>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/companies.js